module.exports = __webpack_public_path__ + "static/media/icon-error.e1198242.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-error.svg
// module id = 1562
// module chunks = 0